import { getJobOfferBaseTypesForCountry, JOB_OFFER_REQUIRED_EXPERIENCES } from '@backend/app-acquisition-logic';

import { JobOfferSort } from '~/constants/jobOffer';

const defaultFormOptions = {
  sort: Object.values(JobOfferSort),
  experience: JOB_OFFER_REQUIRED_EXPERIENCES,
};

export const formOptions = {
  FR: { ...defaultFormOptions, type: getJobOfferBaseTypesForCountry('FR') },
  IT: { ...defaultFormOptions, type: getJobOfferBaseTypesForCountry('IT') },
  US: { ...defaultFormOptions, type: getJobOfferBaseTypesForCountry('US') },
} as const;

export type FormOption = (typeof formOptions)[keyof typeof formOptions];

export type FormOptionKey = keyof FormOption;
